import { Component, OnInit } from '@angular/core';
import { Survey } from '../../classes';
import { flatten } from 'lodash';
import { Subscription } from 'rxjs';
import { SurveyService, RepliesService } from '../../services';
import { LoadingService } from '@schoolbelle/common/loading';
import { ChartsService } from './charts.service';
import { isIE } from '../../functions';

@Component({
  selector: 'app-charts',
  templateUrl: './charts.component.html',
  styleUrls: ['./charts.component.css']
})
export class ChartsComponent implements OnInit {
  survey:Survey;
  subscription = new Subscription();
  constructor(
    public repliesService:RepliesService,
    private surveyService:SurveyService,
    private charts:ChartsService,
    private loading:LoadingService,
  ) { 
  }

  ngOnInit() {
    const surveyData = this.surveyService.data;
    if (!surveyData) throw new Error('surveyData not found!');

    this.survey = new Survey(surveyData.id);
    this.survey.load(this.surveyService.data);
    this.subscription.add(this.repliesService.watch(surveyData.id).subscribe())
  }
  ngOnDestroy () {
    this.subscription.unsubscribe();
    this.repliesService.store.empty();
    this.repliesService.order.empty();
    this.repliesService.filter.empty();
  }
  downloadCharts() {
    if (isIE()) return alert("ì¸í°ë· ìµì¤íë¡ë¬ììë ì§ìíì§ ìë ê¸°ë¥ìëë¤.");
    if (!this.repliesService.currentList) return console.error("wait for list to be loaded first.");
    const subscription = this.charts.downloadCharts(document.querySelectorAll('.question')).subscribe();
    this.loading.open({message:'ê·¸ëí ë´ë ¤ë°ê¸°ë¥¼ ì¤ë¹íê³  ììµëë¤...', busy:subscription});
    
  }
  downloadExcel () {
    if (!this.repliesService.currentList) return console.error("wait for list to be loaded first.");
    const options = flatten(this.survey.questions.map(q=>q.options));
    const subscription = this.charts.downloadExcel(this.repliesService.currentList, options).subscribe();
    this.loading.open({message:'ëªë¶ ë´ë ¤ë°ê¸°ë¥¼ ì¤ë¹íê³  ììµëë¤...', busy:subscription});
        
  }
  trackByIdFn(index:number, val:any){
    return val.id;
  }  
}
